import React, { useState } from "react";
import PropTypes from "prop-types";
import { FiUser, FiChevronUp, FiChevronDown } from "react-icons/fi";

import {
  AccordionHeader,
  AccordionLabel,
  Chevron,
  AccordionContent,
  DataText,
} from "../styles";

export default function PersonalDataAccordion({ user }) {
  const [open, setOpen] = useState(true); // inicia aberto (spec)

  return (
    <div>
      <AccordionHeader type="button" onClick={() => setOpen((v) => !v)}>
        <AccordionLabel>
          <FiUser />
          Dados pessoais
        </AccordionLabel>
        <Chevron>{open ? <FiChevronUp /> : <FiChevronDown />}</Chevron>
      </AccordionHeader>

      {open && (
        <AccordionContent>
          {user?.nome && <DataText>{user.nome}</DataText>}
          {user?.telefone && <DataText>{user.telefone}</DataText>}
          {user?.email && <DataText>{user.email}</DataText>}
        </AccordionContent>
      )}
    </div>
  );
}

PersonalDataAccordion.propTypes = {
  user: PropTypes.object,
};
